<template>
  <MainLayout>
    <div class="container mw-960" slot="layout-body">
      <div class="error-container text-center">
        <img src="/static/images/signin-lcic-inactive.svg">
        <div class="typography--content-body"
             v-html="$t('errors.unauthorized_msg')">
        </div>
        <div class="link-back-to-ct">
          <a v-bind:href="classtingUrl">
            {{ $t('errors.back_to_classting') }}
          </a>
        </div>
      </div>
    </div>

    <AppFooter slot="footer"></AppFooter>
  </MainLayout>
</template>

<script>
  import { CLASSTING_URL } from '@/config';

  export default {
    name: 'forbidden',

    data() {
      return {
        classtingUrl: CLASSTING_URL,
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/errors/views/Forbidden.vue